module.exports = __webpack_public_path__ + "static/media/SignUp3Wave.f2b52b05.svg";